module.exports = __webpack_public_path__ + "img/tl.ba804bba.svg";